import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { Button } from '../prime'
import { Alert } from '../../components';
import UserData from '../../services/userdata';

interface IProps { 
  storage?: IDataStorage;
  setEntityValues: (e: any) => void;
}

interface IState {
  storage?: IDataStorage;
}

class Index extends React.Component<IProps, IState> {

  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    return res;
  }

  render() {
    return (
      <Button 
        icon="pi pi-upload" 
        className="p-button-rounded p-button-success p-button-outlined" 
        tooltip="Recupera los datos guardados en el caché" 
        tooltipOptions={{ position: 'top' }} 
        style={{ marginLeft: 10 }}
        onClick={() => {
          if (this.props.setEntityValues) {
            UserData.get(`form//${window.location.pathname}`)
              .then(res => {
                if (this.props.setEntityValues) {
                  this.props.setEntityValues(res);
                  Alert.info("Caché de datos", "Datos recuperados");
                }
              }, res => Alert.error("Caché de datos", "error obteniendo datos desde el cache"))
              .catch(res => Alert.error("Caché de datos", "error obteniendo datos desde el cache"));
          }
        }}
      />
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
